import React from 'react';
import PropTypes from 'prop-types';
import { ProgressiveImage } from '../ProgressiveImage';
import { RadioButton } from '../RadioButton';
import { isMobile } from '../../lib/shared/dimensions';
import styles from './CardSelectorStage.css';

function CardSelectorStage({cards, selectCard, selectedCards, disabled}) {
    const onSelect = card => () => {
        selectCard(card);
    };

    if (isMobile()) {
        return null;
    };

    return (
        <div className={styles.cards}>
            {cards.map(card => (
                <div
                    className={styles.card}
                    key={card.id}
                >
                    <ProgressiveImage
                        alt='player'
                        src={card.imageUrl}
                        className={styles.cardImage}
                    />
                    <RadioButton
                        label={(
                            <>
                                Pick {card.name}
                                <span style={{color: `var(--level-${card.level})`}}>
                                    LVL 0{card.level}
                                </span>
                            </>
                        )}
                        onClick={onSelect(card)}
                        variant='secondary'
                        withIcon
                        checked={selectedCards.some(selectedCard => selectedCard.id === card.id)}
                        disabled={disabled}
                    />
                </div>
            ))}
        </div>
    );
};

CardSelectorStage.propTypes = {
    cards: PropTypes.array.isRequired,
    selectedCards: PropTypes.array.isRequired,
    selectCard: PropTypes.func.isRequired,
    disabled: PropTypes.bool
};

export {
    CardSelectorStage
};
